import React, { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import StyledNavButton, { NavLink } from './NavButton.styles';
//@ts-ignore
import Hyphenated from 'react-hyphen';
import { useConsumeWeaveTheme } from '@innovyze/stylovyze/lib/hocs/ApplicationWrapper/theme/WeaveContext';
import { useAdpAnalytics, decoratedAttributes, } from '@innovyze/stylovyze/lib/contexts/AdskDataServiceProvider';
export const NavButton = ({ children, icon, to, path, altHighlight, dataCy, }) => {
    const { isWeaveTheme, resolvedRoles } = useConsumeWeaveTheme();
    const match = useRouteMatch({ path: path || to, exact: true });
    const matchAlt = useRouteMatch({ path: altHighlight });
    const linkRef = React.useRef(null);
    const adp = useAdpAnalytics();
    const navLink = (React.createElement(NavLink, { "adp-click": "true", id: `nav-${children?.toString() ?? ''}`, ref: linkRef, to: to },
        icon,
        children));
    // Use ADP to track the underlying HTMLAnchorElement.
    useEffect(() => {
        if (linkRef.current) {
            adp?.trackLink(linkRef.current, linkRef.current.textContent || '', {
                to,
            });
        }
    }, [linkRef]);
    const adpAttrs = decoratedAttributes({
        to,
    });
    return (React.createElement(StyledNavButton, { "data-cy": dataCy, active: !!match || !!matchAlt, color: isWeaveTheme && resolvedRoles['colorScheme.text.default'], activeBackgroundColor: isWeaveTheme &&
            resolvedRoles['button.segmented.active.backgroundColor'], activeBorderColor: isWeaveTheme &&
            resolvedRoles['button.segmented.active.borderColor'], ...adpAttrs },
        React.createElement(Hyphenated, null, navLink)));
};
export default NavButton;
